import { render } from "./faq.vue?vue&type=template&id=cb9be642"
import script from "./faq.js?vue&type=script&lang=js&external"
export * from "./faq.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__